module.exports = __webpack_public_path__ + "img/image38.57e689ca.jpg";